import { render, staticRenderFns } from "./UploadResume.vue?vue&type=template&id=dbfa70e8"
import script from "./UploadResume.vue?vue&type=script&lang=js"
export * from "./UploadResume.vue?vue&type=script&lang=js"
import style0 from "./UploadResume.vue?vue&type=style&index=0&id=dbfa70e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports